import React from 'react';
import { injectIntl } from '../../util/reactIntl';

import css from './ProjectProposalPage.css';

const SectionDetails = props => {
  const { intl, descriptionText, projectProblem, projectIndustryExperience } = props;

  const descriptionTextHtml = descriptionText ? (
    <div>
      <h3 className={css.subHeading}>
        {intl.formatMessage({ id: 'ProjectProposalPage.descriptionHeading' })}
      </h3>
      <div dangerouslySetInnerHTML={{ __html: descriptionText }} />
    </div>
  ) : (
    ''
  );
  const projectProblemHtml = projectProblem ? (
    <div dangerouslySetInnerHTML={{ __html: projectProblem }} />
  ) : (
    ''
  );
  const projectIndustryExperienceHtml = projectIndustryExperience ? (
    <div>
      <h3 className={css.subHeading}>
        {intl.formatMessage({ id: 'ProjectProposalPage.projectMinimumExperienceHeading' })}
      </h3>
      <div dangerouslySetInnerHTML={{ __html: projectIndustryExperience }} />
    </div>
  ) : (
    ''
  );

  return (
    <div className={css.projectDetails}>
      {projectProblemHtml}
      {descriptionTextHtml}
      {projectIndustryExperienceHtml}
    </div>
  );
};

export default injectIntl(SectionDetails);
